import { ListBusinessUnitsCommandInput } from '@amzn/gbsa-orbit-typescript-client';

export const businessUnitKeys = {
  all: ['businessUnits'] as const,
  lists: () => [...businessUnitKeys.all, 'list'] as const,
  list: (filters: Partial<ListBusinessUnitsCommandInput>) =>
    [...businessUnitKeys.lists(), filters] as const,
};
